module.exports = __webpack_public_path__ + "img/background-check.d3904ad5.png";